export default __webpack_public_path__ + "static/media/delete_popup_icon.15546822.svg";